import React from "react";
import arrowLeft from "@imgs/home/arrow_left.png"
import arrowRight from "@imgs/home/arrow_right.png"
import styles from "./index.module.scss"

declare type PropsType = {
  text: string
}

export const Title = (props: PropsType) => {
  return <div className={styles.title}>
    <img src={arrowRight}/>
    <span className={styles.text}>{props.text}</span>
    <img src={arrowLeft}/>
  </div>
}
